import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Tooltip, IconButton, Avatar, Box } from "@mui/material";
import QuestionMarkOutlinedIcon from "@mui/icons-material/QuestionMarkOutlined";
import { useTheme } from "@mui/material/styles";
import UserManual from "./ManualContent";

const UserManualPopup = ({ type }) => {
    const [open, setOpen] = useState(false);
    const [manualContent, setManualContent] = useState("Loading...");
    const theme = useTheme();

    const handleClickOpen = () => {
        setOpen(true);
        fetchManualContent();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const fetchManualContent = () => {
        const url = "/employee-user-manual.html";
        fetch(url)
            .then(response => response.text())
            .then(data => setManualContent(data))
            .catch(() => setManualContent("Failed to load manual."));
    };

    return (
        <>
            <Box
                sx={{
                    marginRight: '10px',
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    }
                }}
            >
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        overflow: 'hidden',
                        transition: 'all .2s ease-in-out',
                        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
                        '&:hover': {
                            background: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.primary.dark,
                        }
                    }}
                    color="inherit"
                >
                    <Tooltip title="User Manual">
                        <IconButton onClick={handleClickOpen}>
                            <QuestionMarkOutlinedIcon color="inherit" stroke={1.5} size="20px" />
                        </IconButton>
                    </Tooltip>
                </Avatar>
            </Box>

            <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
                <DialogTitle>User Manual</DialogTitle>
                <DialogContent>
                    <iframe
                        src="/employer-user-manual.html"
                        width="100%"
                        height="600px"
                        style={{ border: "none" }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default UserManualPopup;
